import { render, staticRenderFns } from "./historic.vue?vue&type=template&id=dbe06ca6&"
import script from "./historic.js?vue&type=script&lang=js&"
export * from "./historic.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports